export default __webpack_public_path__ + "static/media/Ballroll_00369.1345c6c3.png";